import React from 'react'
import styled, { css } from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation } from 'swiper/modules'
import { Swiper as SwiperType } from 'swiper/types'
import 'swiper/css'
import 'swiper/css/free-mode'

const StyledSwiper = styled(Swiper)<{
  $isAccount: boolean
  $isFirstCard: boolean
}>`
  .swiper-wrapper {
    ${({ $isAccount, $isFirstCard }) =>
      $isAccount &&
      !$isFirstCard &&
      css`
        margin-left: 32px !important;
      `}
  }

  .swiper-slide {
    width: auto;
  }
`

export const Carousel: React.VFC<{
  slides: JSX.Element[]
  buttonLeftClassName?: string
  buttonRightClassName?: string
  setSwiperInstance?: (value: SwiperType | null) => void
  allowTouchMove?: boolean
  isAccount?: boolean
  isFirstCard?: boolean
}> = ({
  slides,
  buttonLeftClassName,
  buttonRightClassName,
  setSwiperInstance,
  allowTouchMove = true,
  isAccount = false,
  isFirstCard = false,
}) => {
  return (
    <StyledSwiper
      $isAccount={isAccount}
      $isFirstCard={isFirstCard}
      allowTouchMove={allowTouchMove}
      modules={[FreeMode, Navigation]}
      freeMode={true}
      className={`mySwiper${buttonLeftClassName ?? ''}`}
      slidesPerView={'auto'}
      simulateTouch={false}
      initialSlide={0}
      navigation={{
        prevEl: buttonLeftClassName
          ? `.${buttonLeftClassName}`
          : '.swiper-swipe-left',

        nextEl: buttonRightClassName
          ? `.${buttonRightClassName}`
          : '.swiper-swipe-right',
      }}
      onSwiper={swiper => setSwiperInstance?.(swiper)}
    >
      {slides.map(slide => (
        <SwiperSlide key={slide.key}>{slide}</SwiperSlide>
      ))}
    </StyledSwiper>
  )
}
